<template>
  <div class="main-view">
    <el-radio-group v-model="table.params.check_status" @change="handleTabs" style="margin-bottom:10px;">
      <el-radio-button :label="1">合作经纪人({{table.total_1}})</el-radio-button>
      <el-radio-button :label="2">待审核({{table.total_2}})</el-radio-button>
      <el-radio-button :label="3">已拒绝({{table.total_3}})</el-radio-button>
    </el-radio-group>
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" size="mini">
        <el-form-item label="负责人:" prop="name">
          <el-input clearable v-model.trim="table.params.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="联系电话:" prop="phone">
          <el-input clearable v-model.trim="table.params.phone" placeholder="请输入" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="账号名称:" prop="sub_keyword">
          <el-input clearable v-model.trim="table.params.sub_keyword" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="所在区域:" prop="area">
          <el-cascader
            style="width:100%;"
            clearable
            v-model="table.params.area"
            :options="areaArr"
            :props="{ checkStrictly: false}"
            @change="selArea">
        </el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button class="theneBtn" type="primary" icon="el-icon-search" @click="onSearch">查询 </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="showEdit">创建经纪人</el-button>
    </div>

    <VTable
      has-pagionation
      title=''
      addText='添加'
      :field="getfield()"
      :loading="table.loading"
      :data="table.data"
      :page='table.params.page'
      :pageSize='table.params.count'
      :total='table.total'
      :hasPagionation="true"
      :default-expand-all="true"
      :showOverflowTooltip="true"
      :showSelect="false"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    > 
      <template v-slot:user_count="{row}">
        <el-button type="text" @click="viewInviteDetail(row)">{{row.user_count}}</el-button>
      </template>
      <template v-slot:worker_count="{row}">
        <el-button type="text" @click="viewInviteMasterDetail(row)">{{row.worker_count}}</el-button>
      </template>
      <template v-slot:account_count="{row}">
        <el-button type="text" @click="viewAccountDetail(row)">{{row.account_count}}</el-button>
      </template>
      <template v-slot:province_str="{row}">
        <span>{{row.province_str}}{{row.city_str}}{{row.area_str}}{{row.street_str}}</span>
      </template>
      <template v-slot:status="{row}">
        <span>{{row.status == 1 ? '正常': '禁用'}}</span>
      </template>
      <template v-slot:images="{row}">
        <el-image  style="width: 50px; height: 50px" :src="row.images[0] || ''" :preview-src-list="row.images"></el-image>
      </template>
      <template v-slot:action="{row}">
        <template v-if="table.params.check_status == 1">
          <el-button type="text" icon="el-icon-edit" @click="showEdit(row)">编辑</el-button>
          <el-button type="text" @click='showPass(row)'>修改密码</el-button>
          <el-button type="text" :class="row.status == 1 ? 'delColor' : 'sussColor'" @click="handleStatus(row)">{{row.status == 1 ? '关闭' : '恢复'}}</el-button>
        </template>
        <template v-if="table.params.check_status == 2">
          <el-button type="text"  @click="showAgree(row)">审核通过</el-button>
          <el-button type="text"  @click="showRefuse(row)" class="delColor">拒绝</el-button>
        </template>
      </template>
    </VTable>

    <edit ref="edit" :areaArr="areaArr" @refresh="getTable"></edit>

    <password ref="pass"></password>
    
    <inviteDetailDialog ref="inviteDetailDialogRef"></inviteDetailDialog>
    <inviteDetailMasterDialog ref="inviteDetailMasterDialogRef"></inviteDetailMasterDialog>
    <accountDetailDialog ref="accountDetailDialogRef"></accountDetailDialog>
    <agreeDialog ref="agreeDialogRef" @success="getTable"></agreeDialog>
    <refuseDialog ref="refuseDialogRef" @success="getTable"></refuseDialog>
  </div>
</template>

<script>
import VTable from '@/components/VTable';
import Edit from './components/Edit.vue';
import Password from './components/Passwordplus.vue';
import inviteDetailDialog from './components/inviteDetailDialog.vue';
import inviteDetailMasterDialog from './components/inviteDetailMasterDialog.vue';
import accountDetailDialog from './components/accountDetailDialog.vue';
import agreeDialog from './components/agreeDialog.vue';
import refuseDialog from './components/refuseDialog.vue';
import { mixinTable } from '@/mixins/table.js';
export default {
  name: 'BannerList',
  components: {
    VTable,
    Edit,
    Password,
    inviteDetailDialog,
    inviteDetailMasterDialog,
    accountDetailDialog,
    agreeDialog,
    refuseDialog
  },
  mixins: [mixinTable],
  data() {
    return {
      field: [
        { name: "name", label: "负责人", hidden: false },
        { name: "phone", label: "联系电话", hidden: false },
        { name: "account", label: "代理账号", hidden: false },
        { name: "province_str", label: "所在地区", width: '200', showTooltip:true, hidden: false },
        // { name: "money", label: "已缴纳代理费/元", hidden: false },
        { name: "user_count", label: "邀请好友", hidden: false },
        { name: "worker_count", label: "邀请师傅量", hidden: false },
        { name: "account_count", label: "账号数量", hidden: false },
        { name: "status", label: "状态", hidden: false },
        { name: "create_time", label: "创建时间", width:'160', hidden: false },
        { name: "action", label: "操作", fixed:"right", width: "240", hidden: false }
      ],
      field2: [
        { name: "name", label: "申请人", hidden: false },
        { name: "phone", label: "联系电话", hidden: false },
        { name: "province_str", label: "代理区域",  showTooltip:true, hidden: false },
        { name: "images", label: "门头照片", hidden: false },
        { name: "create_time", label: "创建时间",  hidden: false },
        { name: "action", label: "操作", fixed:"right", width: "150", hidden: false }
      ],
      field3: [
        { name: "name", label: "申请人", hidden: false },
        { name: "phone", label: "联系电话", hidden: false },
        { name: "province_str", label: "代理区域", showTooltip:true, hidden: false },
        { name: "images", label: "门头照片", hidden: false },
        { name: "create_time", label: "创建时间",  hidden: false },
        { name: "check_time", label: "审核时间",  hidden: false },
        { name: "reason", label: "拒绝原因",  hidden: false },
      ],
      areaarr: [],
      table: {
        loading: false,
        params: {
          name: '',
          phone: '',
          province: '',
          city: '',
          area: '',
          sub_keyword:'',
          status:'', // 1正常，2禁用
          check_status: 1, // 1合作经纪人，2待审核，3已拒绝
          page: 1,
          count: 10
        },
        data: [],
        total: 0,
        total_1:'',
        total_2:'',
        total_3:''
      },
      areaArr: [],
    }
  },
  created() {
    this.getTable();
    this.getArea();
  },
  methods: {
    getfield() {
      if(this.table.params.check_status == 1) {
        return this.field
      }else if(this.table.params.check_status == 2) {
        return this.field2
      }else if(this.table.params.check_status == 3) {
        return this.field3
      }
    },
    viewInviteDetail(row) {
      let dom = this.$refs.inviteDetailDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    viewInviteMasterDetail(row) {
      let dom = this.$refs.inviteDetailMasterDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    viewAccountDetail(row) {
      let dom = this.$refs.accountDetailDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    getTable() {
      delete this.areaarr
      this.$http.get('/admin/flex_agency/list', { params:this.table.params }).then(res => {
        if(res.code === 1) {
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.total_1 = res.data.total_1;
          this.table.total_2 = res.data.total_2;
          this.table.total_3 = res.data.total_3;
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    reset() {
      Object.keys(this.table.params).forEach(item => {
        this.table.params[item] = ''
        this.table.params.page = 1
        this.table.params.count = 10
      })
      this.getTable();
    },
    selArea(val) {
      this.table.params.province = val[0]
      this.table.params.city = val[1]
      this.table.params.area = val[2]
    },
    // 获取省、市、区
    getArea() {
      this.$http.post('/common/district/all',{}).then(res => {
        if(res.code == 1) {
          this.areaArr = res.data.list;
        }
      })
    },
    showEdit(row) {
      let dom = this.$refs.edit
      dom.toggle(true)
      if (!!row.id) {
        dom.getDetail(row)
      }
      dom = null
    },
    // 查看
    showDetail(row) {
      let dom = this.$refs.detail
      dom.toggle(true)
      dom.getDetail(row)
      dom = null
    },
    // 关闭/恢复
    handleStatus(row) {
      let str = row.status == 1 ? '关闭' : '恢复';
      this.$confirm(`请确认${str}?`,"提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/admin/flex_agency/operation', { id: row.id }).then(res => {
          if(res.code === 1) {
            this.$message.success('操作成功！')
            this.getTable();
          } else {
            this.$message.error(res.data)
          }
        })
      }).catch(() => {})
    },
    showPass(row) {
      let dom = this.$refs.pass
      dom.toggle(true)
      dom.getDetail(row)
      dom = null
    },
    showAgree(row) {
      let dom = this.$refs.agreeDialogRef
      dom.toggle(true)
      dom.getDetail(row)
      dom = null
    },
    showRefuse(row) {
      let dom = this.$refs.refuseDialogRef
      dom.toggle(true)
      dom.getDetail(row)
      dom = null
    }
  }
}
</script>

<style scoped>
.delColor {
  color: #f56c6c;
}
.sussColor {
  color: #67c23a;
}
</style>